<div class="landing-page-container">
    <app-page-title>
        <h1>DIDO Vendégház</h1>
        <h2>Kikapcsolódás, pihenés és horgászat a Szajki-tavaknál</h2>
    </app-page-title>

    <div class="landing-page-body-container">
        <div class="landing-page-body-content">

            <div class="first-section">
                <h2>
                    A DIDO Vendégház a Szajki-tavak 5-ös tó partján található, ahol a természet közelsége és a csendes környezet garantálja a tökéletes kikapcsolódást.
                    A vendégházunk ideális helyszín családok, baráti társaságok és horgászok számára egyaránt.
                </h2>
                <h3>
                    Fedezze fel a környék szépségeit, élvezze a horgászatot vagy csak pihenjen a természet lágy ölén!
                </h3>
            </div>

            <div class="second-section">
                <app-text-with-image [imageUrl]="'/assets/images/vendeghaz/ajanlo.jpg'" [side]="'left'">
                    <h2 class="image-title">Belső tereink</h2>
                    <p class="image-description">
                        A DIDO Vendégház apartmanja modern és kényelmes berendezéssel várja vendégeit. 
                        Az apartman tágas nappalival és további két kényelmes hálószobával rendelkezik.
                    </p>
                    <app-button [text]="'További információk'" routerLink="rolunk" fragment="belso"></app-button>
                </app-text-with-image>
                
                <app-text-with-image [imageUrl]="'/assets/images/vendeghaz/konyha_1.jpg'" [side]="'right'">
                    <h2 class="image-title">Konyhánk</h2>
                    <p class="image-description">
                        Modern és jól felszerelt konyha várja a vendégeinket, ideális a saját ételek elkészítéséhez.
                        Továbbá az udvaron egy kerti sütögető is található.
                    </p>
                    <app-button [text]="'További információk'" routerLink="rolunk" fragment="konyha"></app-button>
                </app-text-with-image>
            </div>

            <div class="third-section">
                <h2>
                    Az indulásunk, avagy a vírus időszaka
                </h2>
                <h3>
                    A DIDO Vendégház 2020-ban nyitotta meg kapuit a vírushelyzet közben, és azóta is szeretettel várja vendégeit. A ez idő alatt különös figyelmet fordítottunk a biztonságra és a higiéniai intézkedésekre, hogy mindenki nyugodtan pihenhessen. Azóta számos változás történt, amelyek a komfortot és a kényelmet szolgálják.
                </h3>
            </div>

            <div class="fourth-section book-now">
                <h2>
                    Foglalja le most a DIDO Vendégházat, és élvezze a természet közelségét, a csendet és a nyugalmat!
                </h2>
                <h3>Ne habozzon, tapasztalja meg a DIDO Vendégház nyújtotta élményeket!</h3>
                <app-button [text]="'Foglalj most!'" [type]="'primary'" [size]="'large'" (click)="emailSender.email()"></app-button>
            </div>
        </div>
    </div>
</div>